module.exports = __webpack_public_path__ + "static/media/air-ticket-booking.80f6fc96.jpg";